import {useCartItemResource} from "./useCartItemResource";
import {GPAWebDataTypesResourceType} from "../../api/openApi/cartService";
import {WarrantyModel} from "../../models/domain/warrantyModel";
import {useOffCanvasWarranty} from "./useOffCanvasWarranties";

/**
 * Returns the warranty for the current cart item
 * @returns {WarrantyModel | undefined}
 */
export const useCartItemWarranty = (): WarrantyModel | undefined => {
    // Pull the warranty currently apply to the cart item
    const {resource: cartWarranty} = useCartItemResource(GPAWebDataTypesResourceType.Warranty)
    // Pull all warranties for this product from the off canvas product query
    const {productWarranty} = useOffCanvasWarranty(cartWarranty?.resourceId)
    // Return the warranty model, using the price from the cart item warranty, or the price from the product warranty
    return productWarranty ? new WarrantyModel({
        price: cartWarranty?.price ?? productWarranty.price,
        title: productWarranty.title,
        id: productWarranty.id,
        type: productWarranty.type,
        name: productWarranty.name
    }) : undefined;
}